/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit, Renderer2} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MustMatch} from '../../_validators/must-match.validator';
import {I18nService, RESET_PASSWORD_SUCCESS, UserService} from '../../_services/services';
import {Helpers} from '../../helpers';
import {ToastrService} from 'ngx-toastr';
import {BACKGROUND_COLOR, COLOR_PRIMARY_LIGHT, LOGIN_PATH} from '../../_enums/constants';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  private token: string = null;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS GROUPS                                                                                          ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public resetPasswordFG: FormGroup;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGIC FUNCTIONS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private i18n: I18nService,
    private renderer: Renderer2,
    private router: Router,
    protected toastr: ToastrService,
    private userService: UserService
  ) {
    this.renderer.setStyle(document.body, BACKGROUND_COLOR, COLOR_PRIMARY_LIGHT);

    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];

      if (!this.token) {
        this.router.navigate([LOGIN_PATH]);
      }
    });
  }

  ngOnInit() {
    this.resetPasswordFG = this.formBuilder.group({
      password: [null, [Validators.required, Validators.minLength(6)]],
      confirm: [null, [Validators.required]]
    }, {
      validator: MustMatch('password', 'confirm')
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              EMAIL FORM CONTROLS                                                                                   ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get confirm(): AbstractControl {
    return this.resetPasswordFG.get('confirm');
  }

  get password(): AbstractControl {
    return this.resetPasswordFG.get('password');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS SUBMITS                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public resetPasswordFormSubmit() {
    if (this.resetPasswordFG.valid) {
      Helpers.setLoading(true);

      this.userService.resetPassword(this.resetPasswordFG.value.password, this.token).subscribe(() => {
        Helpers.setLoading(false);
        this.toastr.success(this.i18n.get(RESET_PASSWORD_SUCCESS));
        this.router.navigate([LOGIN_PATH]);
      }, (err: HttpErrorResponse) => this.handleError(err));
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);
    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }

}
